@if (chatShowed) {
    <craig-dialog-view></craig-dialog-view>
    <div class="chat-tools-container">
        <div class="chatbox-prompts-container">
            <div class="chatbox-container">
                <div class="textarea-floater">
                    <epd-input-group class="input-group" [suffixTemplate]="suffixTemplateInfoClose">
                        <epd-textarea
                            #queryInput
                            [value]="chatQuery"
                            placeholder="Ask a question or select a question to edit from the sample prompts"
                            [rows]="2"
                            [maxRows]="10"
                            (input)="onChatBoxChange(queryInput.value)"
                            (keydown)="onChatBoxKeydown($event)"
                        ></epd-textarea>
                    </epd-input-group>

                    <ng-template #suffixTemplateInfoClose>
                        <epd-icon
                            class="close-button"
                            size="small"
                            type="x-remove"
                            *ngIf="!isSubmitInProgress && queryInput.value"
                            (mousedown)="clearChatQuery()"
                        ></epd-icon>
                        <epd-icon
                            class="send-button"
                            size="small"
                            type="send"
                            *ngIf="!isSubmitInProgress"
                            (click)="submit()"
                        ></epd-icon>
                        <epd-icon
                            class="abort-button"
                            size="small"
                            type="x-close"
                            *ngIf="isSubmitInProgress"
                            (click)="abortQuery()"
                        ></epd-icon>
                    </ng-template>
                </div>
            </div>
            <craig-sample-prompt (promptUpdated)="handlePromptUpdate($event)"></craig-sample-prompt>
        </div>
        <craig-output-helpers></craig-output-helpers>
    </div>
} @else {
    <craig-instructions-panel></craig-instructions-panel>
}
